import { createFileRoute } from '@tanstack/react-router';

import { DeleteAccountLanding } from 'src/apps/account/app/components/DeleteAccount';

export const Route = createFileRoute('/_auth/_layout/account/delete/landing')({
  component: () => <DeleteAccountLanding variant="browser" />,
});
